module.exports = __webpack_public_path__ + "static/media/JakInterpretowacWynik.912b1073.png";